import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 left-0 w-full bg-gray-100 border-t" }
const _hoisted_2 = ["href", "onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "pi pi-fw pi-angle-up"
}

import { computed, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { useNotification } from '@kyvg/vue3-notification';
  import { getSession } from '@/indexedDB';
  import PdfCalculationCard from '@/components/pdfViews/PdfCalculationCard.vue';
  import { carData } from '@/types';

  interface additioanlMenu {
    label: string;
    icon: string;
    isRoute?: boolean;
    routeName?: string;
    action: (value: string) => void;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

  const router = useRouter();
  const { notify } = useNotification();

  const reportRef = ref(null);
  const data = ref<carData | null>(null);
  const showPDF = async () => {
    data.value = await getSession('car');
    await reportRef.value?.generatePDF();
  };

  const items = computed(() => [
    {
      icon: 'pi pi-calculator',
      command: () => {
        router.push('/calculator');
      },
    },
    {
      icon: 'pi pi-chart-bar',
      command: () => {
        router.push('/analytics');
      },
    },
    {
      icon: 'pi pi-file-pdf',
      command: async () => {
        await showPDF();
      },
    },
    {
      hidden: data.value === null,
      icon: 'pi pi-ellipsis-v',
      items: [
        {
          label: 'Port USA',
          command: () => {
            router.push('/usa-port');
          },
        },
        {
          label: 'Port Klaipeda',
          command: () => {
            router.push('/klaipeda-port');
          },
        },
        {
          label: 'Carfax',
          command: () => {
            router.push('/car-fax');
          },
        },
      ],
    },
    {
      hidden: data.value !== null,
      icon: 'pi pi-download',
      command: async () => {
        await showPDF();
      },
    },
    {
      hidden: data.value !== null,
      icon: 'pi pi pi-times',
      command: async () => {
        data.value = null;
      },
    },
  ]);
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isAndroid = computed(() => /android/i.test(userAgent));
  const isIOS = computed(
    () => /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", {
        'mb-5': isIOS.value,
      }])
    }, [
      _createVNode(_component_Menubar, {
        class: _normalizeClass({
          'px-2': isIOS.value,
        }),
        model: items.value,
        breakpoint: ""
      }, {
        item: _withCtx(({ item, props, hasSubmenu }) => [
          (item.route && (item?.hidden ?? true))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.route,
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  _createElementVNode("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), [
                    _createElementVNode("i", {
                      style: {"font-size":"1.5rem"},
                      class: _normalizeClass(item.icon)
                    }, null, 2),
                    (item.label)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.label), 1))
                      : _createCommentVNode("", true)
                  ], 16, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (item?.hidden ?? true)
              ? (_openBlock(), _createElementBlock("a", _mergeProps({
                  key: 1,
                  href: item.url,
                  target: item.target
                }, props.action), [
                  _createElementVNode("i", {
                    style: {"font-size":"1.5rem"},
                    class: _normalizeClass(item.icon)
                  }, null, 2),
                  (item.label)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.label), 1))
                    : _createCommentVNode("", true),
                  hasSubmenu
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                    : _createCommentVNode("", true)
                ], 16, _hoisted_4))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "model"])
    ], 2),
    (data.value)
      ? (_openBlock(), _createBlock(PdfCalculationCard, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (data.value = null)),
          ref_key: "reportRef",
          ref: reportRef,
          info: data.value?.info,
          shipping: data.value?.shipping
        }, null, 8, ["info", "shipping"]))
      : _createCommentVNode("", true)
  ]))
}
}

})